import(/* webpackMode: "eager" */ "/vercel/path0/src/app/pricing/ai-integration/chatbot/page.tsx");
